import React from 'react';
import { Button } from 'antd';
import { EditFilled } from '@ant-design/icons';
import Title from '@/components/title';
import { DetailItem } from '@/components/dataItem/data-view-item';
import { ICustomer } from '@/interfaces/customer';

interface IProps {
  data?: ICustomer;
  onEdit?: () => void;
}

const CustomerRemarkDetail = ({ data, onEdit }: IProps) => {
  return (
    <>
      <Title customClassName="text-lg text-blue-700" title={`บันทึกช่วยจำ`}>
        <div className="flex flex-row gap-2">
          <Button type="primary" onClick={onEdit} ghost>
            <EditFilled />
            แก้ไข
          </Button>
        </div>
      </Title>
      <div className="flex flex-col gap-3 mt-3">
        <DetailItem label="หมายเหตุ" detail={data?.remark} />
        <DetailItem label="หมายเหตุ (คลัง)" detail={data?.whRemark} />
        <DetailItem label="หมายเหตุ (ขนส่ง)" detail={data?.logisticRemark} />
        <DetailItem label="หมายเหตุ (วางบิล)" detail={data?.billingRemark} />
      </div>
    </>
  );
};

export default CustomerRemarkDetail;
